// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1j8CC45A8YDuVYspyFtvCe"};